import { useState, useEffect } from 'react';
import apiClient from '../api/client';

export const FEATURE_LIMITS = {
  starter: {
    analytics_dashboard: true,
    abc_classification: true,
    basic_insights: true,
    customer_segments: false,    
    rfm_analysis: false,            // ❌ Business+ only
    anomaly_detection: false,       // ❌ Business+ only
    predictive_recommendations: false, // ❌ Professional only
    churn_prediction: false,        // ❌ Professional only
    advanced_charts: false          // ❌ Business+ only
  },
  business: {
    analytics_dashboard: true,
    abc_classification: true,
    basic_insights: true,
    customer_segments: true,
    rfm_analysis: true,
    anomaly_detection: true,
    predictive_recommendations: false, // ❌ Professional only
    churn_prediction: false,           // ❌ Professional only
    advanced_charts: true
  },
  professional: {
    analytics_dashboard: true,
    abc_classification: true,
    basic_insights: true,
    customer_segments: true,
    rfm_analysis: true,
    anomaly_detection: true,
    predictive_recommendations: true,
    churn_prediction: true,
    advanced_charts: true
  }
};

export function useFeatureAccess() {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadSubscription() {
      try {
        const response = await apiClient.get('/subscriptions/status/');
        setSubscription(response.data);
      } catch (error) {
        console.error('Failed to load subscription:', error);
        // Set a default subscription when API fails
        setSubscription({ plan: 'starter' });
      }
      setLoading(false);
    }
    loadSubscription();
  }, []);

  const hasFeature = (featureName) => {
    // ⭐ ADD SAFETY CHECK
    if (!subscription || !subscription.plan) {
      return false; // Default to no access if subscription not loaded
    }
    
    const planFeatures = FEATURE_LIMITS[subscription.plan] || FEATURE_LIMITS.starter;
    return planFeatures[featureName] === true;
  };

  const getPlanName = () => {
    return subscription?.plan || 'starter';
  };

  return { hasFeature, getPlanName, loading, subscription };
}

// export function useFeatureAccess() {
//   const [subscription, setSubscription] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     async function loadSubscription() {
//       try {
//         // Get current user's subscription from API
//         const response = await fetch('/api/subscription/');
//         const data = await response.json();
//         setSubscription(data);
//       } catch (error) {
//         console.error('Failed to load subscription:', error);
//       }
//       setLoading(false);
//     }
//     loadSubscription();
//   }, []);

//   const hasFeature = (featureName) => {
//     if (!subscription) return false;
//     const planFeatures = FEATURE_LIMITS[subscription.plan] || FEATURE_LIMITS.starter;
//     return planFeatures[featureName] === true;
//   };

//   const getPlanName = () => {
//     return subscription?.plan || 'starter';
//   };

//   return { hasFeature, getPlanName, loading, subscription };
// }

